<template>
<div class="container">
  <transition name="fade" v-if="downloading">
    <div class="schedule-downloading">下载准备中...</div>
  </transition>
  <ul class="schedule-tab">
    <li></li>
    <li class="time-tab" :class="{active: navType === 'all'}">
      <a href="javascript:;" @click="navSwitch('all')">
        全部
        <br/>
        <!-- <small>全部日程</small> -->
        <a class="small" @click="download">全部日程（点击下载）</a>
      </a>
    </li>
    <li v-for="(item, key) in $store.state.info.scheduleDays" :key="key" :class="{active: navType === key}" class="time-tab">
      <a href="javascript:;" @click="navSwitch(key)" >
        {{item.type === 'training' ? '培训' : '会议 · '}}{{item.index | formatDay}}
        <br/>
        <small>{{  item.date | formatTime(item.dateEnd)}}</small>
      </a>
    </li>
    <li></li>
  </ul>

  <div id="schedule">
    <div style="background-color: #fff" :id="'schedule' + (index+1)" class="table-item" v-for="(item, index) in $store.state.info.scheduleDays" :key="index">
      <h2 v-show="navType === 'all'">
        {{item.type === 'training' ? '培训' : '会议 · '}}{{item.index | formatDay}}
      </h2>
      <h4 v-show="navType === 'all'">
        ({{  item.date | formatTime(item.dateEnd)}})
      </h4>
      <c-table
        v-show="navType === index || navType === 'all'"
        :data="$store.state.schedules"
        :config="item"
        :topics="$store.state.topics"
        :lectures="$store.state.lectures"
        :speakers="$store.state.speakers"></c-table>
    </div>
  </div>
</div>
</template>

<script>
import moment from 'moment'
import CTable from './Table.vue'
import JSPDF from 'jspdf'
import html2canvas from 'html2canvas'
import analysis from '@/utils'

export default {
  created: function () {
  },
  filters: {
    formatDay: function (index) {
      let day = { 0: '一', 1: '二', 2: '三', 3: '四', 4: '五', 5: '六' }
      return day[index] ? `第${day[index]}天` : ''
    },
    formatTime: function (value, valueto) {
      let weeks = { 1: '周一', 2: '周二', 3: '周三', 4: '周四', 5: '周五', 6: '周六', 0: '周日' }
      let m = moment(value)
      if (valueto) {
        let m2 = moment(valueto)
        return m.utcOffset('+08:00').format('YYYY/MM/DD') + '-' + m2.utcOffset('+08:00').format('DD ') + weeks[m.day()] + '，' + weeks[m2.day()]
      } else {
        return m.utcOffset('+08:00').format('YYYY/MM/DD ') + weeks[m.day()]
      }
    }
  },
  data: function () {
    return {
      colspans: { 'day1': [6, 1, 1], 'day2': [2, 1, 1, 1, 1, 1, 1] },
      navType: 'all',
      downloading: false
    }
  },
  components: {
    CTable
  },
  methods: {
    navSwitch: function (type) {
      this.navType = type
    },
    download () {
      // 下载点击谷歌统计
      analysis.GA('send', 'event', 'QCon北京2019-日程下载点击')
      this.downloading = true
      var that = this
      var scheduleDays = this.$store.state.info.scheduleDays

      // var pdf = new jsPDF()
      var pdf = new JSPDF('p', 'pt', 'a2')

      var run = (index) => {
        var sch = document.querySelector(`#schedule${index + 1}`)
        try {
          html2canvas(sch, {
            allowTaint: true,
            useCORS: true,
            onrendered (canvas) {
              let imgData = canvas.toDataURL('image/jpeg')
              // pdf.addImage(imgData, 'JPEG', 10, 10, 190, 277);
              // pdf.addImage(imgData, 'JPEG', 100, 20, 990, 1643)
              let height
              if (990 * canvas.height / canvas.width > 1643) {
                height = 1643
              } else {
                height = 990 * canvas.height / canvas.width
              }
              pdf.addImage(imgData, 'JPEG', 100, 20, 990, height)
              index++
              if (index >= scheduleDays.length || index > 5) {
                pdf.save('QCon广州2019日程')
                that.downloading = false
              } else {
                pdf.addPage()
                run(index)
              }
            }
          })
        } catch (e) {
          // console.log(e)
          that.downloading = false
        }
      }
      run(0)
    }
  }
}
</script>

<style lang="sass" scoped>
.fade-enter-active, .fade-leave-active
  transition: opacity 2s
.fade-enter, .fade-leave-to
  opacity: 0
.schedule-downloading
  position: fixed
  top: 0
  left: 0
  bottom: 0
  right: 0
  z-index: 10000
  display: flex
  justify-content: center
  align-items: center
  background-color: rgba(255,255,255,0.8)
  color: var(--primary-color)
  font-size: 30px

.schedule-tab
  margin: 0 auto
  width: 100%
  display: flex
  list-style: none
  justify-content: center
  padding: 0px

.schedule-tab .time-tab
  width: 222px
  height: 65px
  background-color: #F5F7F8
  text-align: center
  font-size: 15px
  border-left: 1px solid #D0D7DF
  border-top: 1px solid #D0D7DF
  border-bottom: 1px solid #D0D7DF
  display: flex
  justify-content: center
  align-items: center

.schedule-tab .time-tab a
  margin: 0
  padding: 0
  list-style: none
  line-height: 1em
  text-decoration: none
  font-size: 16px
  color: #3e3a39
  font-weight: 500

.schedule-tab .time-tab a small, .schedule-tab .time-tab a.small
  font-size: 12px
  color: #898989
.schedule-tab .time-tab a.small:hover
  opacity: 0.7

.schedule-tab li:first-child
  background-color: #fff
  flex: 1 1 auto
  border-bottom: 1px solid #D0D7DF

.schedule-tab li:last-child
  border-left: 1px solid #D0D7DF
  border-bottom: 1px solid #D0D7DF
  background-color: #fff
  flex: 1 1 auto

.schedule-tab .active
  background-color: #fff
  border-bottom: hidden

.schedule-tab .active a, .schedule-tab .active a.small
  color: var(--primary-color)

.schedule-tab .active a small
  color: var(--primary-color)

.table-item
  // width: 80%
  margin: 4rem auto 0 auto
  // margin-bottom: 100px

.table-item h2
  margin-bottom: 0px
  font-size: 24px
  text-align: center
  margin-top: 57px
  color: var(--primary-color)

.table-item h4
  font-size: 16px
  text-align: center
  color: var(--primary-color)
  margin-top: 6px
  margin-bottom: 30px

</style>
